import CrudCustom from '../../../libs/custom/CrudCustom';

let TipePenghasilanLamp1771ivs = new CrudCustom('/tipe-penghasilan-lamp-1771-ivs');
export default TipePenghasilanLamp1771ivs;